import React, { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";

import { ModalError } from "../../../../components";

interface AdminModalErrorProps {
  isOpen: boolean;
  onClosed: () => void;
  errorType: string;
  setErrorType: any;
}

const AdminModalError: FC<AdminModalErrorProps> = ({ isOpen, onClosed, errorType, setErrorType }) => {
  const { loginWithRedirect } = useAuth0();

  const { t } = useTranslation("register_admin");

  const login = (e: React.MouseEvent | React.FormEvent) => {
    e.preventDefault();
    loginWithRedirect({
      redirectUri: `${window.location.origin}/validar`,
    });
    return undefined;
  };
  const getError = () => {
    interface IerrorsList {
      [key: string]: any;
    }
    const errorsList: IerrorsList = {
      already_registered_error: {
        errorTitle: t("already_registered_error"),
        errorMsg: t("already_registered_error_description"),
        onClickSecondary: () => {
          setErrorType("possible_reasons_error");
        },
        btnTextPrimary: t("try_again"),
        btnTextSecondary: t("possible_reasons_link"),
        btnIdSecondary: "btn_possibleReasons",
      },
      generic_error: {
        errorTitle: t("generic_error"),
        errorMsg: t("generic_error_description"),
        btnTextPrimary: t("generic_error_btn_text"),
      },
      possible_reasons_error: {
        errorTitle: t("possible_reasons_error"),
        errorMsg: (
          <div>
            <strong>O CNPJ está incorreto:</strong>
            <span>
              <br /> Verifique se você digitou o número correto e tente de novo
            </span>
            <strong>
              <br />
              <br />O CNPJ já foi cadastrado:
            </strong>
            <span>
              <br />
              Verifique se a empresa já possui cadastro no VoeBiz e{" "}
              <a
                onClick={(e) => {
                  login(e);
                }}
              >
                {" "}
                acesse a conta{" "}
              </a>
              <br />
            </span>
            <strong>
              <br />O CPF ou e-mail já foi cadastrado:
            </strong>
            <span>
              <br />
              Verifique se o CPF ou e-mail do gestor da conta já estão cadastrados em outra conta.
            </span>
            <strong>
              <br />
              <br />
              <br />
              <br />
              Ainda precisa de ajuda?{" "}
            </strong>
            <span>
              Entre em contato com a <a href="/atendimento"> Central de Atendimento VoeBiz. </a>
            </span>
          </div>
        ),
        btnTextPrimary: t("try_again"),
      },
    };

    return {
      idTitle: "lbl_titleCnpjExisting",
      idMessage: "lbl_msgInformativeCnpjExisting_1",
      handleCloseModal: () => onClosed(),
      onClickPrimary: () => onClosed(),
      btnPrimaryColor: "primary",
      btnIdPrimary: "btn_retrievePassword",
      ...errorsList[errorType],
    };
  };

  const modalErrorData = useMemo(() => getError(), [errorType]);

  return <ModalError {...modalErrorData} isOpen={isOpen} onClosed={onClosed} />;
};

export default AdminModalError;
